var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"colour-legend",class:{'dark-mode': _vm.dark, 'light-mode':!_vm.dark}},_vm._l((_vm.items),function(item,key){return _c('span',{key:key,staticClass:"legend-item"},[_c('span',{staticClass:"colour-icon",style:({backgroundColor:item.colour})}),_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }